import api from './api';

export interface CompanySettings {
  /** 本人の画面からの打刻を許すか。false なら共用端末からのみ */
  self_punch_enabled?: boolean;
  /** 共用端末からの打刻が有効か */
  kiosk_enabled?: boolean;
  id: number;
  company_code: string;
  company_name: string;
  auto_break_deduction_enabled: boolean;
  break_rules: { workHours: number; breakMinutes: number }[];
  standard_work_start_time: string | null;
  standard_work_end_time: string | null;
  standard_work_hours: number;
  timezone: string;
  holiday_monday: boolean;
  holiday_tuesday: boolean;
  holiday_wednesday: boolean;
  holiday_thursday: boolean;
  holiday_friday: boolean;
  holiday_saturday: boolean;
  holiday_sunday: boolean;
  holiday_national_holidays: boolean;
  night_shift_start?: string;
  night_shift_end?: string;
  created_at: string;
  updated_at: string;
}

export const companiesService = {
  // 企業設定取得
  async getSettings(): Promise<CompanySettings> {
    const response = await api.get<CompanySettings>('/companies/settings');
    return response.data;
  },

  // 企業設定更新
  async updateSettings(data: Partial<CompanySettings>): Promise<CompanySettings> {
    const response = await api.put<CompanySettings>('/companies/settings', data);
    return response.data;
  },
};
